(function () {
    // Ejecutar inmediatamente cuando el DOM está listo
    function removeCanonicalOnSearch() {
        // Verifica si estamos en una página de búsqueda
        if (window.location.pathname.includes('/search')) {
            // Busca todas las etiquetas canonical
            var canonicalTags = document.querySelectorAll('link[rel="canonical"]');

            // Elimina cada etiqueta canonical encontrada
            canonicalTags.forEach(function (tag) {
                tag.parentNode.removeChild(tag);
            });
        }
    }

    // Ejecutar cuando el DOM está completamente cargado
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', removeCanonicalOnSearch);
    } else {
        removeCanonicalOnSearch();
    }

    // También ejecutar después de que todos los recursos (incluyendo scripts) se hayan cargado
    window.addEventListener('load', removeCanonicalOnSearch);

    // Ejecutar periódicamente para asegurarse de que scripts que se ejecutan después no añadan la etiqueta
    setInterval(removeCanonicalOnSearch, 500);
})();